import * as types from './types';

const INITIAL_STATE = {
  report: null,
  loading: false,
  loadError: null,
  selectedSites: [],
  grades: [],
};

export default (state = INITIAL_STATE, { payload, type }) => {
  switch (type) {
    case types.UNAPPLIED_STUDENTS_REPORT_LOADING:
      return { ...state, loading: payload };
    case types.UNAPPLIED_STUDENTS_REPORT_LOAD_ERROR:
      return {
        ...state,
        loadError: {
          Title: 'Error',
          Message: payload
            ? payload
            : 'An error has occurred. Please try again',
        },
      };
    case types.UNAPPLIED_STUDENTS_REPORT_GET_REPORT:
      return {
        ...state,
        report: payload,
      };
    case types.UNAPPLIED_STUDENTS_REPORT_SET_SELECTED_SITES:
      return {
        ...state,
        selectedSites: payload,
      };
    case types.UNAPPLIED_STUDENTS_REPORT_CLEAR_ERRORS:
      return {
        ...state,
        loadError: null,
      };
    default:
      return state;
    case types.UNAPPLIED_STUDENTS_REPORT_GET_GRADES:
      // format grades for form dropdown and add all option to front of array
      const grades = payload.data.map(grade => {
        return {
          value: grade.Id,
          text: grade.Id + ' ' + grade.Description,
        };
      });
      grades.unshift({ value: 'ALL', text: 'ALL' });
      return {
        ...state,
        grades: grades,
      };
  }
};



// WEBPACK FOOTER //
// ./src/pages/unappliedstudents/state/report/reducer.js